import type { IconProps } from './../../models/icon';

export function CalendarIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M2.57146 3.42856C2.1168 3.42856 1.68077 3.60918 1.35928 3.93066C1.03779 4.25215 0.857178 4.68818 0.857178 5.14284V21.4286C0.857178 21.8832 1.03779 22.3193 1.35928 22.6407C1.68077 22.9622 2.1168 23.1428 2.57146 23.1428H21.4286C21.8832 23.1428 22.3193 22.9622 22.6408 22.6407C22.9622 22.3193 23.1429 21.8832 23.1429 21.4286V5.14284C23.1429 4.68818 22.9622 4.25215 22.6408 3.93066C22.3193 3.60918 21.8832 3.42856 21.4286 3.42856H2.57146Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M6 0.857117V5.99997"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18 0.857117V5.99997"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M6 3.42856H14.5714"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.99997 11.1428C6.47335 11.1428 6.85711 10.7591 6.85711 10.2857C6.85711 9.81232 6.47335 9.42856 5.99997 9.42856C5.52658 9.42856 5.14282 9.81232 5.14282 10.2857C5.14282 10.7591 5.52658 11.1428 5.99997 11.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 11.1428C12.4733 11.1428 12.8571 10.7591 12.8571 10.2857C12.8571 9.81232 12.4733 9.42856 12 9.42856C11.5266 9.42856 11.1428 9.81232 11.1428 10.2857C11.1428 10.7591 11.5266 11.1428 12 11.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18 11.1428C18.4733 11.1428 18.8571 10.7591 18.8571 10.2857C18.8571 9.81232 18.4733 9.42856 18 9.42856C17.5267 9.42856 17.1428 9.81232 17.1428 10.2857C17.1428 10.7591 17.5267 11.1428 18 11.1428Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.99997 18C6.47335 18 6.85711 17.6161 6.85711 17.1428C6.85711 16.6694 6.47335 16.2857 5.99997 16.2857C5.52658 16.2857 5.14282 16.6694 5.14282 17.1428C5.14282 17.6161 5.52658 18 5.99997 18Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 18C12.4733 18 12.8571 17.6161 12.8571 17.1428C12.8571 16.6694 12.4733 16.2857 12 16.2857C11.5266 16.2857 11.1428 16.6694 11.1428 17.1428C11.1428 17.6161 11.5266 18 12 18Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M2.57146 3.42856C2.1168 3.42856 1.68077 3.60918 1.35928 3.93066C1.03779 4.25215 0.857178 4.68818 0.857178 5.14284V21.4286C0.857178 21.8832 1.03779 22.3193 1.35928 22.6407C1.68077 22.9622 2.1168 23.1428 2.57146 23.1428H21.4286C21.8832 23.1428 22.3193 22.9622 22.6408 22.6407C22.9622 22.3193 23.1429 21.8832 23.1429 21.4286V5.14284C23.1429 4.68818 22.9622 4.25215 22.6408 3.93066C22.3193 3.60918 21.8832 3.42856 21.4286 3.42856H18"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
